import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import * as React from "react";

export const orderNumberStyles: SearchTextFieldStyles = {};
const styles = orderNumberStyles;

const OrderHistorySearchFieldWONumber: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            styles={styles}
            parameterField={"woNumber" as keyof GetOrdersApiParameter}
            label={translate("Work Order #", "Work Order #")}
            inputType="text"
            placeholder=""
            testSelector="orderHistory_filterOrderNumber"
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchFieldWONumber,
    definition: {
        group: "Order History",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
        displayName: "WO Number",
    },
};

export default widgetModule;
